import type { City, SkyWebcam } from '../domain/index.ts';

/**
 * Ermont — valeurs confirmées via geo.api.gouv.fr le 2026-09-18 (docs/02 §6) :
 * code INSEE 95219, code postal 95120, centre [2.258, 48.9891].
 * Emprise calculée à partir du contour officiel de la commune.
 */
export const ERMONT: City = {
  slug: 'ermont',
  name: 'Ermont',
  inseeCode: '95219',
  postalCodes: ['95120'],
  department: { code: '95', name: "Val-d'Oise" },
  region: 'Île-de-France',
  country: 'FR',
  timeZone: 'Europe/Paris',
  center: { lat: 48.9891, lon: 2.258 },
  bbox: [2.242082, 48.976309, 2.273843, 49.001853],
};

/**
 * Webcam de ciel la plus proche trouvée le 2026-09-22 (aucune à Ermont ; celle d'Enghien-les-Bains n'est pas
 * intégrable). Caméra d'un particulier (webcam.ballet-online.com) publiée sur Windy, coordonnées Windy
 * 48.91071, 2.17933 : 10,4 km au cap 213° depuis le centre d'Ermont. Elle regarde La Défense (cap ~116°),
 * soleil du matin dans le champ. Conditions Windy : crédit « Webcams provided by Windy.com » et lien vers la
 * page de la webcam, image non déformée. Lecteur public : aucun cookie, uniquement webcams.windy.com.
 */
export const ERMONT_SKY_WEBCAM: SkyWebcam = {
  name: 'Carrières-sur-Seine : La Défense',
  place: 'Carrières-sur-Seine',
  distanceKm: 10,
  fromCity: 'au sud-ouest',
  facing: 'vers La Défense, à l’est-sud-est',
  embedUrl: 'https://webcams.windy.com/webcams/public/embed/player/1299660563/day',
  pageUrl: 'https://www.windy.com/webcams/1299660563',
  credit: { text: 'Webcams provided by Windy.com', url: 'https://www.windy.com' },
  caveat:
    'Ce n’est pas le ciel d’Ermont mais celui de la boucle de la Seine : utile en journée et au lever du soleil ; au coucher, la caméra tourne le dos au soleil.',
  verifiedAt: '2026-09-22',
};
